/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowphotologo3Inputs */

const en_aiflowphotologo3 = /** @type {(inputs: Aiflowphotologo3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo`)
};

const de_aiflowphotologo3 = /** @type {(inputs: Aiflowphotologo3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo`)
};

/**
* | output |
* | --- |
* | "Logo" |
*
* @param {Aiflowphotologo3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowphotologo3 = /** @type {((inputs?: Aiflowphotologo3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowphotologo3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowphotologo3(inputs)
	return de_aiflowphotologo3(inputs)
});
export { aiflowphotologo3 as "aiFlowPhotoLogo" }